module.exports = __webpack_public_path__ + "img/ios-information-circle.4792d284.svg";